import { type FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton.tsx';
import { ModalBody } from 'dibs-elements/exports/ModalBody.tsx';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { Button } from 'dibs-elements/exports/Button.tsx';

import dibsCss from 'dibs-css';

type Props = {
    onClose: () => void;
};

const TradeBenefitsInReviewModal: FC<Props> = ({ onClose }) => {
    return (
        <ModalContainer isOpen onClose={onClose} modalPosition="center">
            <ModalCloseButton onClick={onClose} />

            <ModalBody>
                <HeadingLevel>
                    {Heading => (
                        <Heading
                            className={classnames(
                                dibsCss.textCenter,
                                dibsCss.sassyFontHeaderMedium,
                                dibsCss.mySmall
                            )}
                        >
                            <FormattedMessage
                                id="abt.TradeBenefitsInReviewModal.header"
                                defaultMessage="We Are Reviewing Your Profile"
                            />
                        </Heading>
                    )}
                </HeadingLevel>
                <p className={dibsCss.sassyFontBody}>
                    <FormattedMessage
                        id="abt.TradeBenefitsInReviewModal.body"
                        defaultMessage="Our team is currently reviewing your information. Once we verify your professional status, one of our trade specialists will be in touch to show you how to take advantage of your exclusive trade program benefits."
                    />
                </p>
                <div className={dibsCss.mtLarge}>
                    <Button href="/" fullWidth style="circle">
                        <FormattedMessage
                            id="abt.TradeBenefitsInReviewModal.button"
                            defaultMessage="Shop Now"
                        />
                    </Button>
                </div>
            </ModalBody>
        </ModalContainer>
    );
};

export { TradeBenefitsInReviewModal };
